module.exports = __webpack_public_path__ + "img/hr-red-asterisk-09.e6cf3daf.png";